/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".signature-pad{width:100%;min-height:200px;display:block}.signature-pad-canvas{border:1px dashed #c7c7c7}.btn-clear{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}"];
export { styles as styles };
